import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import {
  MetabaseDashboardToken,
  MetabaseDashboardTokenQuery,
  MetabaseDashboardTokenQueryVariables,
} from "generated/graphql";

const getIframeUrl = (token: string) => {
  return `${process.env.REACT_APP_METABASE_SITE_URL}/embed/dashboard/${token}#bordered=true&titled=true`;
};

export const useMetabaseReport = (dashboard: MetabaseDashboardToken) => {
  const { data, loading } = useQuery<
    MetabaseDashboardTokenQuery,
    MetabaseDashboardTokenQueryVariables
  >(queries.GET_METABASE_DASHBOARD, {
    variables: { dashboard }
  });

  return {
    iframeUrl: (data && !loading) ? getIframeUrl(data.metabaseDashboardToken) : "",
    loading,
  };
};
